import { Component, ViewChild } from '@angular/core';
import { Platform, Nav, ModalController, AlertController, Keyboard } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Deeplinks } from '@ionic-native/deeplinks';
declare var IonicDeeplink;
declare var AppRate;

import { ApiService } from "../services/api.service";
import { MruService } from "../services/mru.service";
import { OneSignalService } from "../services/one-signal.service";

import { HomePage } from "../pages/home/home";
import { LoginPage } from "../pages/login/login";
import { ProfilePage } from "../pages/profile/profile";
import { ChangePasswordPage } from "../pages/change-password/change-password";
import { TabsPage } from '../pages/tabs/tabs';
import { XpTabsPage } from '../pages/xp-tabs/xp-tabs';
import { XpSearchUnitPage } from "../pages/xp-search-unit/xp-search-unit";
import { ReportService } from "../services/report.service";
import { DataService } from "../services/data.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage:any = XpTabsPage;
  pages: Array<{title: string, component: any, id?: string}>;

  constructor(
      public platform: Platform,
      public statusBar: StatusBar,
      public splashScreen: SplashScreen,
      public modalCtrl: ModalController,
      public deeplinks: Deeplinks,
      public mru: MruService,
      public oneSignal: OneSignalService,
      public translate: TranslateService,
      public alertCtrl: AlertController,
      public reportService: ReportService,
      public dataService: DataService,
      public keyboard: Keyboard,
      public apiService: ApiService
  ) {
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      // Guard every native plugin call: on a browser deploy there is no
      // cordova bridge (cordova.js is a no-op stub) and these calls throw,
      // which silently aborts the rest of the ready() callback and leaves
      // the app rendered as a blank ion-app shell. platform.is('cordova')
      // is true only on a real device.
      var isCordova = false;
      try { isCordova = platform.is('cordova'); } catch (e) { isCordova = false; }
      if (isCordova) {
        try { statusBar.styleLightContent(); } catch (e) {}
        try { statusBar.overlaysWebView(false); } catch (e) {}
        try { statusBar.backgroundColorByHexString('#000000'); } catch (e) {}
        try { splashScreen.hide(); } catch (e) {}
      }
      // Disable back button
      try { this.platform.registerBackButtonAction(() => {},101); } catch (e) {}
      // Register deeplinks
      try { this.registerDeeplinks(); } catch (e) {}
      // Setup AppRate (native rating prompt — cordova-only)
      if (isCordova) {
        try { this.setupAppRate(); } catch (e) {}
      }
      // Setup OneSignal (push notifications — cordova-only)
      if (isCordova) {
        try { this.oneSignal.setup(); } catch (e) {}
      }
    });
    this.pages = [
      { title: 'Mijn profiel', component: ProfilePage },
      { title: 'Wachtwoord wijzigen', component: ChangePasswordPage },
      { title: 'Daredevil', component: null, id: 'daredevil' }
    ];
    translate.setDefaultLang('es');
    translate.use('es');
  }

  openPage(page) {
    if(page.id && page.id == 'daredevil') {
      this.openDaredevil();
    } else if(page.component === LoginPage) {
      this.logout();
    } else if(page.component === HomePage) {
      // Gym build: never fall back to the legacy Dutch HVAC HomePage tree.
      this.rootPage = XpTabsPage;
      this.nav.setRoot(XpTabsPage);
    } else {
      this.nav.push(page.component);
    }
  }

  openDaredevil() {
    this.dataService.openFeedbackForm();
  }

  loginToPreviousToken(){
    this.apiService.loginToPreviousToken().then(() => {
      this.reportService.clearData();
      this.alertCtrl.create({
        title: this.translate.instant('Uw bedrijf'),
        message: this.translate.instant('U bent nu weer ingelogd bij uw bedrijf.'),
        buttons: [this.translate.instant('OK')]
      }).present();
    });
  }

  logout(){
    this.apiService.logout().then(() => {
      this.reportService.clearData();
      if(this.nav.getActive().component === HomePage) {
        // Call HomePage.openLogin() if active
        this.nav.getActive().instance.openLogin();
      } else {
        // Open modal
        let modal = this.modalCtrl.create(LoginPage, {}, {
          enableBackdropDismiss: false,
          cssClass: 'modal-fullscreen'
        });
        modal.present();
      }
    }).catch((err) => {
      console.error(err);
      alert('Logout error');
    });
  }

  setupAppRate(){
    if (typeof AppRate != 'undefined') {
      let language = (this.translate.currentLang ? this.translate.currentLang : 'nl');
      let customLocale = {
        title: this.translate.instant("Wilt u een beoordeling achterlaten voor de %@ app?"),
        message: this.translate.instant("Dit neemt slechts enkele minuten in beslag. Bedankt voor uw steun!"),
        cancelButtonLabel: this.translate.instant("Nee"),
        laterButtonLabel: this.translate.instant("Herinner me later"),
        rateButtonLabel: this.translate.instant("Beoordeling doorgeven"),
        yesButtonLabel: this.translate.instant("Ja!"),
        noButtonLabel: this.translate.instant("Nee, niet echt"),
        appRatePromptTitle: this.translate.instant('Wilt u de %@ app beoordelen?'),
        feedbackPromptTitle: this.translate.instant('Wilt u feedback achterlaten?'),
      };
      AppRate.setPreferences({
        useLanguage: language,
        simpleMode: true,
        customLocale: customLocale,
        usesUntilPrompt: 3,
        storeAppURL: {
          ios: '1471325086',
          android: 'market://details?id=com.maintenanz.app'
        },
        openUrl: (url) => {
          window.open(url, '_system', 'location=yes');
        }
      });
      AppRate.promptForRating(false);
    }
  }

  registerDeeplinks(){
    if(this.platform.is('ios')) {
      // Setup IOS MRU deeplink
      if (typeof IonicDeeplink != 'undefined') {
        IonicDeeplink.route({
          '/': 'home'
        }, (match) => {
          // match.$route - the route we matched, which is the matched entry from the arguments to route()
          // match.$args - the args passed in the link
          // match.$link - the full link data
          console.log('Successfully matched route', match);
        }, (nomatch) => {
          // nomatch.$link - the full link data
          console.error('Got a deeplink that didn\'t match', nomatch);
          // Handle MRU response
          let url = nomatch.$link.path;
          this.mru.triggerResponseCallback(url);
        });
      } else {
        console.log('IonicDeeplink undefined');
      }
    } else {
      // Setup Android QR code deeplink (gym tabs root, not the legacy HVAC home)
      this.deeplinks.route({
        '/:code': XpTabsPage
      }).subscribe(match => {
        // match.$route - the route we matched, which is the matched entry from the arguments to route()
        // match.$args - the args passed in the link
        // match.$link - the full link data
        console.log('Successfully matched route', match);
        if(match.$args && match.$args.code){
          this.searchUnitByCode(match.$args.code);
        }
      }, nomatch => {
        // nomatch.$link - the full link data
        console.error('Got a deeplink that didn\'t match', nomatch);
      });
    }
  }

  searchUnitByCode(code){
    let searchUnitTabIndex = 3;
    let navs = this.nav.getActiveChildNavs();
    let tabs = navs[0];
    tabs.select(searchUnitTabIndex).then(() => {
      setTimeout(() => {
        tabs.getSelected().setRoot(XpSearchUnitPage, {
          code: code
        });
      }, 500);
    });
  }

  isKeyboardOpen() {
    return this.keyboard.isOpen();
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts